module.exports = __webpack_public_path__ + "img/thumb_15.977d7618.jpg";